<template>
  <div class="popups" id="popups" :style="{ 'z-index': Pindex }">
    <SpritesC :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <modifyUserItem :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <charactersSprite :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <spriteRightKey :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <gif-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <frame-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <path-target-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <font-family :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <!-- <font-family popupName="fontFamilyCloud"       :boxDatas="boxDatas" :dataMsg="dataMsg"/> -->
    <scenesSetting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <timelineFlag :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <font-size :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <chart-table :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <chart-type :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <shortcuts :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <text-to-voice :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <scene-effect :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <searchHistroy :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <volume :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <vipEquity :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <vipSprites :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <uploadFile :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <spritesStore :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <effect-options :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <select-frame-image :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <frame-widget :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <video-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <stayEffect :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <artTextSetting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <timelineRightKey :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <selectSpritesEffect :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <SettingMessage :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <cropping :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <!-- <version-update></version-update> -->
    <switch-version></switch-version>

    <internalInvitation  v-if="TopnavMsg.isInternaInvitation"></internalInvitation>
    <examine-draft  v-if="TopnavMsg.isExamineMember"></examine-draft>
    <!-- old -->
    <!-- <imgSettingT       :boxDatas="boxDatas" :dataMsg="dataMsg"/> -->
    <!-- <text-setting      :boxDatas="boxDatas" :dataMsg="dataMsg"/> -->
    <!-- <svg-setting       :boxDatas="boxDatas" :dataMsg="dataMsg"/> -->
    <!-- <lottie-setting    :boxDatas="boxDatas" :dataMsg="dataMsg"/> -->
    <!-- <chart-setting     :boxDatas="boxDatas" :dataMsg="dataMsg"/> -->
    <!-- <enter-exit-effect :boxDatas="boxDatas" :dataMsg="dataMsg" :directionType="'to'"/> -->

    <!-- popups new -->
    <sprite-popup :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <basic-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <effect-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <style-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <align-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <filter-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <shadow-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <lottie-motion :boxDatas="boxDatas" :dataMsg="dataMsg" />

    <!-- popups new bg -->
    <bg-popup :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <basic-setting-bg :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <zoom-setting-bg :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <bg-laying-setting :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <video-bg-duration :boxDatas="boxDatas" :dataMsg="dataMsg" />

    <!-- after popups new because of ZIndex -->
    <color-picker :boxDatas="boxDatas" :dataMsg="dataMsg" />

    <color-picker-cloud :boxDatas="boxDatas" :dataMsg="dataMsg" />

    <in-out-effect :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <drawing-duration :boxDatas="boxDatas" :dataMsg="dataMsg" />

    <custom-works :boxDatas="boxDatas" :dataMsg="dataMsg" />
    <course :boxDatas="boxDatas" :dataMsg="dataMsg" />
  </div>
</template>

<script>
//  弹窗组件，所欲设置的弹窗组件
import { mapGetters } from "vuex";

import SpritesC from "./popups/secondPopups/spritesClick.vue"; // 二级弹窗-元素图层设置    （主动需要关闭操作的弹窗）
import modifyUserItem from "./popups/secondPopups/modifyUserItem.vue"; // 二级弹窗-场景元素修改title    （主动需要关闭操作的弹窗）
import SettingMessage from "./popups/secondPopups/settingMessage.vue"; // 二级弹窗-信息修改弹窗--负责元素取消收藏的按钮    （主动需要关闭操作的弹窗）
import charactersSprite from "./popups/secondPopups/charactersSprite.vue"; // 二级弹窗-获取角色元素    （主动需要关闭操作的弹窗）
import vipEquity from "./popups/vipPopups/vipEquity.vue"; // 二级弹窗-会员权益提示    （主动需要关闭操作的弹窗）
import vipSprites from "./popups/vipPopups/vipSprites.vue"; // 二级弹窗-会员权益提示    （主动需要关闭操作的弹窗）

// import imgSettingT     from './popups/imgSettingTrigger.vue' // 一级弹窗-图片元素设置     （可触发关闭式）
// import textSetting     from './popups/textSetting.vue'      // 一级弹窗-文本设置        （可触发关闭式）
// import svgSetting      from './popups/svgSetting.vue'       // 一级弹窗-svg设置        （可触发关闭式）
// import lottieSetting   from './popups/lottieSetting.vue'    // 一级弹窗-lottie设置     （可触发关闭式）
// import chartSetting    from './popups/chartSetting.vue'     // 一级弹窗-图表设置
// import enterExitEffect from './popups/enterExitEffect.vue'  // 一级弹窗-进出场动画设置
import lottieMotion from "./popups/lottieMotion.vue"; // 一级弹窗-lottie动作设置     （可触发关闭式）
import spriteRightKey from "./popups/spriteRightKey.vue"; // 一级弹窗-元素右键功能设置 （可触发关闭式）
import colorPicker from "./popups/colorPicker.vue"; // 一级弹窗-颜色功能设置     （可触发关闭式）
import colorPickerCloud from "./popups/colorCloud.vue";
import fontFamily from "./popups/fontFamily.vue"; // 一级弹窗-文字字体功能设置 （可触发关闭式）
import scenesSetting from "./popups/scenesSetting.vue"; // 一级弹窗-分组设置        （可触发关闭式）
import gifSetting from "./popups/gifSetting.vue"; // 一级弹窗-gif设置        （可触发关闭式）
import frameSetting from "./popups/frameSetting"; // 一级弹窗-相框设置        （可触发关闭式）
import timelineFlag from "./popups/timelineFlag.vue"; // 一级弹窗-时间轴的flag弹窗
import fontSize from "./popups/fontSize.vue"; // 一级弹窗-文字字体大小设置
import chartTable from "./popups/chartTable.vue"; // 一级弹窗-图表数据表格
import chartType from "./popups/chartType.vue"; // 一级弹窗-快速切换图表类型弹窗
import shortcuts from "./popups/shortcuts.vue"; // 一级弹窗-快捷键弹窗
import textToVoice from "./popups/mySoundRecord.vue"; // 一级弹窗-文字转语音
import sceneEffect from "./popups/sceneEffect.vue"; // 一级弹窗-转场动画设置
import volume from "./popups/volume.vue"; // 一级弹窗-音量调节
import searchHistroy from "./popups/searchHistroy.vue"; // 一级弹窗-搜索历史
import uploadFile from "./popups/uploadFile.vue"; // 一级弹窗-上传文件
import spritesStore from "./popups/spritesStore.vue"; // 一级弹窗-小程序素材定制-- 废弃
import versionUpdate from "./popups/versionUpdatePopup.vue"; // 初始化版本更新弹框
import switchVersion from "./popups/switchVersion.vue"; // 新老版本编辑器切换提示弹框
import internalInvitation from "./popups/internalInvitation.vue"; // 内测编辑器邀请弹框

import examineDraft from "./popups/examineDraft.vue"; // 初始化版本更新弹框

import effectOptions from "./popups/effectOptions.vue"; // 一级弹窗-上下左右移入移出的选择弹窗
import pathTargetSetting from "./popups/pathTargetSetting.vue"; // 一级弹窗-路径动画target设置
import selectFrameImage from "./popups/selectFrameImage"; // 一级弹窗-选择相框图片
import frameWidget from "./popups/frameWidget"; // 一级弹窗-相框编辑小部件
import videoSetting from "./popups/videoSetting.vue"; // 一级弹窗-视频素材设置
import stayEffect from "./popups/stayEffect"; // 一级弹窗-停留动画快捷设置
import artTextSetting from "./popups/artTextSetting"; // 一级弹窗-艺术字选择设置
import timelineRightKey from "./popups/timelineRightKey"; // 一级弹窗-时间轴上的镜头右键

import selectSpritesEffect from "./popups/selectSpritesEffect"; // 一级弹窗-多选元素出入场动画设置

// new
import spritePopup from "./popupsNew/spritePopup"; // 一级弹窗
import basicSetting from "./popupsNew/basicSetting/basicSetting"; // 一级弹窗
import effectSetting from "./popupsNew/effectSetting/effectSettingIndex"; // 一级弹窗
import styleSetting from "./popupsNew/textSetting/styleSetting"; // 一级弹窗
import alignSetting from "./popupsNew/textSetting/alignSetting"; // 一级弹窗
import bgPopup from "./popupsNew/bgPopup";
// import bgSetting      from './popups/bgSetting.vue'       // 一级弹窗-背景设置
import basicSettingBg from "./popupsNew/basicSetting.bg/basicSetting.bg.vue";
import zoomSettingBg from "./popupsNew/zoomSetting.bg/zoomSetting.vue";
import bgLayingSetting from "./popups/bgLayingSetting"; // 一级弹窗-背景铺设设置
import videoBgDuration from "./popups/videoBgDuration.vue"; // 一级弹窗-视频背景播放时间
import inOutEffect from "./popupsNew/inOutEffect/inOutEffect.vue"; // 一级弹窗
import drawingDuration from "./popupsNew/drawingDuration"; // 一级弹窗
import filterSetting from "./popupsNew/filterSetting/filterSetting"; // 一级弹窗
import shadowSetting from "./popupsNew/shadowSetting/shadowSetting"; // 一级弹窗
import customWorks from "./popupsNew/customWorks"; // 一级弹窗
import course from "./popups/course"; // 一级弹窗
import cropping from "./popupsNew/cropping"; // 一级弹窗

export default {
  data() {
    return {
      boxDatas: {
        firstDatas: [], // 一级弹窗数据数组，控制层级（可触发关闭式）
        secondData: [], // 二级弹窗数据数组，控制层级（主动需要关闭操作的弹窗）
      },
      dataMsg: {},
      actionBox: false,
      Pindex: 25,
      stopClose: false,
      // isVersionUpdate: false,
    };
  },
  computed: {
    ...mapGetters(["TopNav_Size", "TOOL",'TopnavMsg']),
  },
  mounted() {
    this.$bus.on("FeaturesPop_vue", (data) => {
      let rightKey = Array.indexOf(
        this.boxDatas.firstDatas,
        "sprite_right_key"
      );
      if (rightKey >= 0) {
        this.$bus.emit("FeaturesPop_close_vue", {
          name: "sprite_right_key",
          type: 1,
        });
      }
      this.dataMsg[data.name] = data;
      // 进出场设置弹窗 enterExitEffect.vue 将要显示时，先关闭其他一级弹窗
      if (data.name === "effect" || data.name === "inOutEffect") {
        this.$set(this.boxDatas, "firstDatas", []);
      }
      switch (data.name) {
        case "vipEquity":
        case "vipPayment":
        case "color":
          this.Pindex = 9999;
          break;
        default:
          this.Pindex = 25;
          break;
      }
      if (data.type === 1) {
        // 一级可被触发关闭弹窗
        let judgeOnlyOne = Array.indexOf(this.boxDatas.firstDatas, data.name);
        if (judgeOnlyOne === -1) {
          this.boxDatas.firstDatas.push(data.name);
        } else {
          return;
        }
      } else if (data.type === 2) {
        // 二级弹窗主动关闭切换关闭
        let judgeOnlyOne = Array.indexOf(this.boxDatas.secondData, data.name);
        if (judgeOnlyOne === -1) {
          this.boxDatas.secondData.push(data.name);
        } else {
          return;
        }
      }
      this.actionBox = true;
    });
    this.$bus.on("FeaturesPop_close_vue", (data) => {
      // 关闭弹窗，一，二级弹窗
      if (data.name === "setting_Bg" && this.stopClose) {
        this.stopClose = false;
        return;
      }
      if (data.type === 1) {
        let index = this.boxDatas.firstDatas.indexOf(data.name);
        if (index > -1) {
          this.boxDatas.firstDatas.splice(index, 1);
        }
      }
      if (data.type === 2) {
        let index = this.boxDatas.secondData.indexOf(data.name);
        if (index > -1) {
          this.boxDatas.secondData.splice(index, 1);
        }
      }
      if (data.type === 3) {
        // 关掉所有弹窗
        let dataMsgObject = {};
        let dataMsgList = [];
        if (this.dataMsg.vipEquity) {
          dataMsgObject.vipEquity = Object.assign(this.dataMsg.vipEquity);
          dataMsgList.push(dataMsgObject.vipEquity.name);
        }
        this.boxDatas.firstDatas = [];
        this.boxDatas.secondData = dataMsgList;
        this.dataMsg = dataMsgObject;
      }
      if (data.name) {
        delete this.dataMsg[data.name];
      }
      this.closeBoxJudgeZindex();
    });
    window.onmousedown = (event) => {
      if (event.target.closest(".stroke-width-dropdown")) {
        return;
      }
      this.$bus.emit("windowMousedown_vue", { data: true });
      if (this.boxDatas.firstDatas.length) {
        // 触发关闭弹窗
        for (let i = 0; i < this.boxDatas.firstDatas.length; i++) {
          delete this.dataMsg[this.boxDatas.firstDatas[i]];
        }
        this.boxDatas.firstDatas = [];
      }
    };
    document.onmousemove = (event) => {
      this.$bus.emit("Document_mousemove_vue", event);
    };
    document.onmouseup = (event) => {
      this.$bus.emit("Document_mouseup_vue", event);
    };
    document.onmouseleave = (event) => {
      this.$bus.emit("Document_mouseup_vue", event);
    };

    this.$bus.on("bgZoom.playScene", () => {
      this.stopClose = true;
    });
  },
  methods: {
    closeBoxJudgeZindex() {
      let Boxname = ["vipEquity", "vipPayment", "color"];
      for (let i = 0; i < Boxname.length; i++) {
        if (Boxname[i] in this.dataMsg) {
          this.Pindex = 40;
          break;
        } else {
          this.Pindex = 25;
        }
      }
    },
  },
  components: {
    SpritesC,
    spriteRightKey,
    lottieMotion,
    scenesSetting,
    gifSetting,
    frameSetting,
    fontFamily,
    colorPicker,
    colorPickerCloud,
    timelineFlag,
    fontSize,
    chartTable,
    chartType,
    shortcuts,
    textToVoice,
    modifyUserItem,
    sceneEffect,
    volume,
    charactersSprite,
    vipEquity,
    vipSprites,
    searchHistroy,
    uploadFile,
    videoBgDuration,
    effectOptions,
    pathTargetSetting,
    spritesStore,
    selectFrameImage,
    frameWidget,
    videoSetting,
    stayEffect,
    artTextSetting,
    timelineRightKey,
    bgLayingSetting,
    selectSpritesEffect,
    spritePopup,
    basicSetting,
    effectSetting,
    styleSetting,
    alignSetting,
    bgPopup,
    basicSettingBg,
    zoomSettingBg,
    inOutEffect,
    drawingDuration,
    filterSetting,
    shadowSetting,
    SettingMessage,
    customWorks,
    course,
    cropping,
    versionUpdate,
    switchVersion,
    internalInvitation,
    examineDraft
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.popups {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 24;
}
</style>



// WEBPACK FOOTER //
// src/components/Popups.vue